import React from "react";
import { Switch, Route, BrowserRouter, } from "react-router-dom";
import Login from "./page/login/login";
import RouterPage from "./page/router_page";
import LandingPage from "./page/landing/landing-page";
import SignUpPage from "./page/login/sign_up";
import Salir from "./page/salir";
import PrivacyPolicyPage from "./page/public/privacy_policy";
import ProgramacionCamionesExternalPage from "./page/public/programacion-camiones-external";
import EnviadoPage from "./page/public/enviado-page";
// import DashboardPage from "./page/dashboard";

const RouterMain = () => {
  // const { path } = useRouteMatch();
  // console.log('RouterMain');
  // console.log(path);
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/landing">
          <LandingPage />
        </Route>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/sign-up">
          <SignUpPage />
        </Route>
        <Route exact path="/salir">
          <Salir />
        </Route>
        <Route exact path="/privacy-policy">
          <PrivacyPolicyPage />
        </Route>
        <Route exact path="/programacion-camiones-external/:idEmpresa">
          <ProgramacionCamionesExternalPage />
        </Route>
        <Route exact path="/enviado">
          <EnviadoPage />
        </Route>
        <Route path="/">
          <RouterPage />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default RouterMain;
